import React from 'react';
import Badge from '@mui/material/Badge';
import c from 'classnames';

import Avatar from '../Avatar';
import { BADGE_BACKGROUND_COLOR_MAP, BADGE_POSITION_MAP, badgeStyleMap } from '../styles';
import { AvatarWithBadgeProps } from '../types';

const BADGE_ANCHOR_ORIGIN: React.ComponentProps<typeof Badge>['anchorOrigin'] = {
  horizontal: 'right',
  vertical: 'bottom',
};
const AvatarWithBadge = React.forwardRef<HTMLDivElement, AvatarWithBadgeProps>((props, ref) => {
  const { className, size = 'x-large', status, ...rest } = props;

  return (
    <Badge
      anchorOrigin={BADGE_ANCHOR_ORIGIN}
      className={className}
      classes={{
        dot: c(
          'min-w-0 rounded-full transform-none absolute border border-solid border-icon-white',
          BADGE_BACKGROUND_COLOR_MAP[status],
          BADGE_POSITION_MAP[size],
          badgeStyleMap(size),
        ),
      }}
      overlap="circular"
      variant="dot">
      <Avatar ref={ref} size={size} {...rest} />
    </Badge>
  );
});

export default React.memo(AvatarWithBadge);
